module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/folk-v2-160e8e413ff0227bc67783b081be2271.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/folk-v2.svg
// module id = qJEW
// module chunks = 1 3 10 12 18